import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NoPipeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const value = control.value;
    if (typeof value === 'string' && value.includes('|')) {
      return { noPipe: 'Position title cannot contain a pipe character (|)' };
    }
    return null;
  };
}
